import { makeAutoObservable } from 'mobx';
import { groupByFunction } from './utils/rxjs/groupByFunction';

export class ActivityLogsStore {
  root;
  logs = {};
  logsByTradePlanId = {};
  logsSubject;
  removeLogsSubject;

  constructor(root) {
    makeAutoObservable(this);
    this.root = root;
    this.initializeStream();
  }

  initializeStream = () => {
    this.logsSubject = groupByFunction(
      'messageType',
      'notifications',
      this.root.websocketSubject
    ).subscribe((msg) => {
      if (msg.notificationDetails?.TRADE_PLAN?.type === 'ALERT') return;
      this.updateLogsStore(msg);
      if (msg.notificationDetails?.TRADE_PLAN) this.updateLogsByTpIdStore(msg);
    });

    this.removeLogsSubject = groupByFunction(
      'messageType',
      'removeNotifications',
      this.root.websocketSubject
    ).subscribe((msg) => this.handleLogsRemoveMsg(msg));
  };

  updateLogsStore = (msg) => {
    if (
      msg.notificationId &&
      msg.notificationDetails &&
      msg.notificationDetails?.notificationType
    ) {
      this.logs[msg.notificationId] = msg;
    }
  };

  updateLogsByTpIdStore = (msg) => {
    if (
      msg.notificationId &&
      msg.notificationDetails &&
      msg.notificationDetails?.notificationType
    ) {
      const id = msg.notificationDetails?.TRADE_PLAN?.id ?? null;
      if (id) {
        if (!this.logsByTradePlanId[id]) {
          this.logsByTradePlanId[id] = {
            [msg.notificationId]: msg,
          };
        } else {
          this.logsByTradePlanId[id][msg.notificationId] = msg;
        }
      }
    }
  };

  handleLogsRemoveMsg = (msg) => {
    delete this.logs[msg.id];
    //todo send up tradeplan id
    for (const tradePlanId in this.logsByTradePlanId) {
      for (const notificationId in this.logsByTradePlanId[tradePlanId]) {
        if (notificationId === msg.id) {
          delete this.logsByTradePlanId[tradePlanId][msg.id];
        }
      }
    }
  };

  get logListInChronologicalOrder() {
    const arr = Object.keys(this.logs);
    if (arr.length > 100)
      return arr
        .sort((a, b) => {
          const aTime = new Date(this.logs[a].date).getTime();
          const bTime = new Date(this.logs[b].date).getTime();
          return bTime - aTime;
        })
        .slice(0, 99);
    else
      return arr.sort((a, b) => {
        const aTime = new Date(this.logs[a].date).getTime();
        const bTime = new Date(this.logs[b].date).getTime();
        return bTime - aTime;
      });
  }
}
